import { render } from "./GuideComponent.vue?vue&type=template&id=3c86d68d&scoped=true"
import script from "./GuideComponent.vue?vue&type=script&lang=js"
export * from "./GuideComponent.vue?vue&type=script&lang=js"

import "./GuideComponent.vue?vue&type=style&index=0&id=3c86d68d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c86d68d"]])

export default __exports__